import React from "react";
import { Award, Star, HeartPulse } from "lucide-react";
import { nurses } from "../mock";

export default function Nurses() {
  if (!nurses || nurses.length === 0) return null;

  return (
    <section id="nurses" className="relative px-4 md:px-8 pb-20 md:pb-28">
      <div className="mx-auto max-w-[1400px]">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-end mb-14">
          <div>
            <span className="eyebrow">Our nursing team</span>
            <h2 className="section-title">Compassionate nursing care</h2>
          </div>
          <p className="text-[#4a4a63] leading-relaxed lg:max-w-md lg:ml-auto">
            Our practice nurses work alongside our doctors to deliver seamless, high-quality care — from vaccinations and health assessments to wound care and chronic-disease support.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
          {nurses.map((n) => (
            <article
              key={n.id}
              className="relative rounded-[32px] bg-white border border-[#eee6f7] shadow-sm overflow-hidden"
            >
              <div className="absolute left-0 top-0 bottom-0 w-1.5 bg-gradient-to-b from-[#3dc9b3] to-[#1a2464]" />

              <div className="p-8 md:p-10">
                <div className="flex items-start gap-4 mb-5">
                  <span className="shrink-0 w-14 h-14 rounded-2xl bg-[#3dc9b3]/15 grid place-items-center">
                    <HeartPulse className="w-7 h-7 text-[#3dc9b3]" />
                  </span>
                  <div>
                    <div className="inline-flex items-center gap-2 bg-[#3dc9b3]/15 text-[#1a2464] font-semibold text-[11px] px-3 py-1 rounded-full">
                      <Award className="w-3 h-3 text-[#3dc9b3]" />
                      {n.role}
                    </div>
                    <h3 className="text-2xl md:text-3xl font-bold text-[#1a2464] leading-tight mt-2">
                      {n.name}
                    </h3>
                    <div className="text-[#4a4a63] text-sm mt-1">{n.creds}</div>
                  </div>
                </div>

                <p className="text-[#4a4a63] leading-relaxed">{n.bio}</p>

                {n.interests?.length > 0 && (
                  <div className="mt-8 pt-6 border-t border-[#eee6f7]">
                    <div className="text-[#1a2464] font-bold mb-3 text-xs uppercase tracking-widest">
                      Highlights
                    </div>
                    <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-2">
                      {n.interests.map((it) => (
                        <li key={it} className="flex items-start gap-3">
                          <span className="mt-0.5 shrink-0 w-5 h-5 rounded-full bg-[#3dc9b3]/15 grid place-items-center">
                            <Star className="w-3 h-3 text-[#3dc9b3]" fill="#3dc9b3" />
                          </span>
                          <span className="text-[#1a1a2e] text-sm">{it}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
